<template>
  <div class="hzc-price-index">
    <div class="back">当前位置：<span @click="back('/zetar')">煤焦油加工</span> > <span
        @click="back('/zetar/twoPage/price')">价格</span> > 正文
    </div>
    <DetailTitle :title="$route.query.id+'煤焦油区域价格'"></DetailTitle>
    <el-table
        :data="tableData"
        :header-cell-style="{background:'#f2f2f2',color:'#222'}"
        border
        :max-height="400"
        style="width: 100%;margin-top: 20px;">
      <el-table-column
          align="center"
          label="选择">
        <template slot-scope="scope">
          <div v-if="scope.row['lineCharFlag']!==false">
          <span :class="{'slot-hover' : dictId === scope.row['dictId']}" class="slot-span"
                v-if="dictId === scope.row['dictId']">已选择</span>
            <span class="slot-span" @click="chooseEchars(scope)" v-else>显示曲线</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          prop="druidParamName"
          width="300"
          label="指标名称">
      </el-table-column>
      <el-table-column align="center" v-for="(item,index) in tabHead" :key="index">
        <template slot="header">
          <span>{{ item }}</span>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row[`price${index + 1}`] }}</span>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          prop="floatPrice"
          label="涨跌幅">
        <template slot-scope="scope">
          <FloatPrice :floatPrice="scope.row['floatPrice']"/>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          prop="unitName"
          label="单位">
      </el-table-column>
    </el-table>
    <div class="echarts">
      <div id="myChart" style="width: 1100px;height:340px;"></div>
    </div>
  </div>
</template>

<script>
import DetailTitle from '@/components/common/detatilTitle'
import {zetarPriceDetail, priceDetailData} from '@/api/zetar'

export default {
  name: "priceIndex",
  components: {
    DetailTitle
  },
  data() {
    return {
      flag: 'issue_material_add_area_price',
      tableData: [],
      tabHead: [],
      dictId: '',
    }
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      zetarPriceDetail({dictDataType: this.flag, endTime: this.$route.query.id}).then(res => {
        this.tableData = res.data.data;
        this.dictId = this.tableData[0]['dictId'];
        this.tabHead = res.data['titleList'];
        this.getMapData()
      })
    },
    /**
     * 获取地图信息
     */
    getMapData() {
      let option = {
        title: {
          text: "区域价格"
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',
          data: []
        },
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月']
        },
        yAxis: {},
        series: [
        ],
        dataZoom: [{
          type: 'inside',//图表下方的伸缩条
          show: true, //是否显示
          realtime: true, //拖动时，是否实时更新系列的视图
          start: 0, //伸缩条开始位置（1-100），可以随时更改
          end: 100, //伸缩条结束位置（1-100），可以随时更改
        }],
        grid: {
          x: 100,
          y: 50,
          x2: 10,
          y2: 50
        },
      }
      priceDetailData({dictDataType: this.flag, dictId: this.dictId,endTime: this.$route.query.id}).then(res => {
        option['xAxis']['data'] = res.data['coordinate']
        res.data.dataList.map(item => {
          let obj = {
            name: item.yearName,
            type: "line",
            connectNulls:true,
            data: item.priceList
          }
          option.series.push(obj);
          option.legend.data.push(item.yearName)
        })
        this.drawChart(option);
      })
    },
    /**
     * 切换tabs
     */
    changeTabs(num) {
      this.flag = num;
      this.getDetail();
    },
    back(url) {
      this.$router.push({path:url, query:{flag:'issue_material_add_area_price'}});
    },
    /**
     * 选择地图
     */
    chooseEchars(row) {
      this.dictId = row.row['dictId']
      this.getMapData()
    },
    /**
     * 加载地图
     */
    drawChart(option) {
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      myChart.setOption(option);
    }
  },
  mounted() {
    this.getDetail();
    /**
     * 加载地图
     */
  }
}
</script>

<style scoped lang="less">
.hzc-price-index {
  width: 1200px;
  margin: 0 auto;

  .tabs {
    margin: 15px 0;

    div {
      display: inline-block;
      margin-right: 16px;
      padding: 0 10px;
      height: 36px;
      background: #F2F2F2;
      border-radius: 4px;
      border: 1px solid #CCCCCC;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
    }

    div:hover {
      background-color: #D3131A;
      color: #fff;
    }
  }

  .slot-span {
    display: inline-block;
    text-align: center;
    line-height: 25px;
    width: 74px;
    height: 25px;
    background: #F2F2F2;
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    cursor: pointer;
  }

  .slot-span:hover {
    background-color: #D3131A;
    border: 1px solid #D3131A;
    color: #fff;
  }

  .slot-hover {
    background-color: #D3131A;
    border: 1px solid #D3131A;
    color: #fff;
  }

  .echarts {
    margin-top: 24px;
    width:1140px;
    height: 351px;
    background: #FFFFFF;
    box-shadow: 0px 2px 10px 0px rgba(183, 183, 183, 0.5);
    padding: 30px;
  }
}

.hover {
  background-color: #D3131A !important;
  border: 1px solid #D3131A !important;
  color: #fff;
}

.back{
  span {
    cursor: pointer;
  }
}
.red {
  color: #EA6535;
}

.green {
  color: #079F93;
}

.gray {
  color: #999999;
}
</style>
